import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MainService} from 'src/app/Services/service.service';
import {displayModeType} from 'src/app/Adv/search-results/search-results.component';
import {PageEvent} from '@angular/material';
import {DTOAdvertisementEx} from 'src/app/api/LocalModels';
import * as moment from "moment";
import {DTOAdvertisement, ShowAdType} from "../../api/WickedApiClient";
import {ViewMode} from "../../Services/advertisement.service";
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-adv-user-advertisements',
  templateUrl: './adv-user-advertisements.component.html',
  styleUrls: ['./adv-user-advertisements.component.css']
})
export class AdvUserAdvertisementsComponent implements OnInit {

  public advLoading: boolean = true;

  constructor(public route: ActivatedRoute, public service: MainService) {
    this.service.advService.searchInActionChanged.subscribe(s => {
      this.advLoading = s;
    });
  }

  ngOnInit() {
    if(!this.service.userService.isDemo()) {
      this.viewMode = ViewMode.ACTIVE;
    }
    this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = 0;
    this.performSearch();
  }

  public performSearch() {
    this.currentUserId = this.service.userService.getUserId();
    this.service.advService.searchDataUserAdv.currentSearchRule.userId = this.currentUserId;
    this.service.advService.searchActionForUser(this.viewMode);
  }

  private _currentUserId: number;
  public get currentUserId(): number {
    return this._currentUserId;
  }

  public set currentUserId(value: number) {
    this._currentUserId = value;
  }


  public get length() {
    return this.service.advService.searchDataUserAdv.resultCount;
  }

  public get pageSize() {
    return this.service.advService.searchDataUserAdv.currentSearchRule.pageSize;
  }

  public get pageNumber() {
    return this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber;
  }


  pageSizeOptions: number[] = [5, 10, 25, 100];

  public _pageEvent: PageEvent;
  public get pageEvent(): PageEvent {
    return this._pageEvent;
  }

  public set pageEvent(value: PageEvent) {
    this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = value.pageIndex;
    this.service.advService.searchDataUserAdv.currentSearchRule.pageSize = value.pageSize;
    this.service.advService.searchActionForUser(this.viewMode);
    this._pageEvent = value;
  }

  public listLayoutType = displayModeType;
  public _listLayout: displayModeType = displayModeType.LIST;

  public get listLayout(): displayModeType {
    return this._listLayout;
  }

  public set listLayout(value: displayModeType) {
    this._listLayout = value;
  }


  private _viewMode: ViewMode = ViewMode.ALL;


  get viewMode(): ViewMode {
    return this._viewMode;
  }


  set viewMode(value: ViewMode) {
    this._viewMode = value;
  }

  public advIsExpired(adv): boolean {
    return adv.dateStart.isSameOrBefore(moment().subtract(14, 'day'))
  }

  public get cardList(): DTOAdvertisementEx[] {
    return this.service.advService.searchDataUserAdv.resultList;
  }

  // public getLocation(id:number)
  // {
  //   if(this.service.advService.getRegionNameById(id))
  //   {
  //      return this.service.advService.getRegionNameById(id).name;
  //   }
  //   else
  //   {
  //     return "";
  //   }
  // }

  getPremiumText(advertisement: DTOAdvertisementEx) {
    if(advertisement.showAs == ShowAdType.PremiumAd) {
      return "Premium Ad";
    } else if(advertisement.showAs == ShowAdType.PremiumUser) {
      return "Premium User";
    } else if(advertisement.isPremium) {
      if(advertisement.isPremiumUser) {
        return "Premium User";
      } else {
        return "Premium Ad";
      }
    }

    return "";
  }

  public getImageFromCard(card: DTOAdvertisementEx) {
    if(card.images.length > 0) {
      let mainImage = card.images.filter(v => v.isMain == true);

      if(mainImage.length > 0) {
        return `${environment.apiBaseUrl}/FileGet/${mainImage[0].fileName}`;
      } else {
        return `${environment.apiBaseUrl}/FileGet/${card.images[0].fileName}`;
      }

    } else {
      return "";
    }
  }


  openAdv(id: string) {
    this.service.route.navigate([`adv-edit/${id}`]);
  }

  viewModeIsActive() {
    return this.viewMode == ViewMode.ACTIVE;
  }

  viewModeIsExpired() {
    return this.viewMode == ViewMode.EXPIRED;
  }

  setViewMode(newMode: string) {
    if(newMode == 'ACTIVE') {
      this.viewMode = ViewMode.ACTIVE
    } else if(newMode == 'EXPIRED') {
      this.viewMode = ViewMode.EXPIRED;
    } else this.viewMode = ViewMode.ALL;

    this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = 0;
    this.performSearch()
  }

  repostAdv(adv: DTOAdvertisement) {
    //this.service.advService.repost(adv.advertisementId).then(res => {
    //  this.service.showInformation('Your ad was reposted for next 14 days');
    //  adv.dateStart = moment()
    //}).catch(err => {
    //  this.service.showError(err);
    //})
  }
}


